<template>
    <div class="invest">
      <div class="banner-top">
        <div class="banner-box"></div>
        <div class="banner-desc">标准化投顾产品，涵盖付费内参、股票池、战绩回测和运营软文</div>
      </div>
      <div class="invest-box">
        <el-row :gutter="20">
<!--          <el-col :span="8" v-for="(item, i) in menuList" :key="i">-->
          <el-col :span="12" v-for="(item, i) in menuList" :key="i">
            <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="third-tooltip">
            <div class="grid-content bg-purple cursorPointer" @click="token && selectMenu(i)">
              <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
            </div>
            </el-tooltip>
          </el-col>
        </el-row>

        <div class="list" v-show="currentIndex === ''">
          <div class="list-box" v-for="(item,i) in itemList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=invest'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 0">
          <div class="list-box" v-for="(item,i) in itemDxList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=invest'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getDxMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 1">
          <div class="zx-list">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="全部" name="second">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemZxList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=invest'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList">
                          <li v-for="(item, i) in itemTjAllList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getZxMore();getAllTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="每月专题精研" name="fourth">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemJyList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=invest'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-jy">
                          <li v-for="(item, i) in itemTjJyList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getJyMore();getJyTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="研选专题金股" name="five">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemYxList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=invest'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList-yx">
                          <li v-for="(item, i) in itemTjYxList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getYxMore();getYxTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="list" style="display:none;" v-show="currentIndex === 2">
          <el-table
            :data="itemCxList"
            @row-click="handlePreview"
            style="width: 100%">
            <el-table-column
              prop="stockName"
              label="股票名称"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="stockCode"
              label="股票代码"
              width="120">
            </el-table-column>
            <el-table-column
              prop="sectionstart,sectionend"
              label="调仓价格"
              width="100">
              <template slot-scope="scope">
                {{scope.row.sectionstart}}--{{scope.row.sectionend}}
              </template>
            </el-table-column>
            <el-table-column
              prop="takeprofit"
              label="止盈"
              width="50">
            </el-table-column>
            <el-table-column
              prop="stoploss"
              label="止损"
              width="50">
            </el-table-column>
            <el-table-column
              prop="themeName"
              label="题材"
              width="80">
            </el-table-column>
            <el-table-column
              prop="selectedreason"
              label="备注"
              >
            </el-table-column>
            <el-table-column
              prop="source"
              label="机构来源"
              >
            </el-table-column>
            <el-table-column
              prop="selecteddate"
              label="调仓日期"
              width="120">
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
      <div class="back-top" @click="backTop" v-show="btnFlag">
        <img src="../assets/images/return_top.png" alt="" srcset="">
      </div>
      <preview v-if="VisiAble" ref="dialog"></preview>
    </div>
</template>

<script>
import { InvestAll, Dx, Zx, Cx, ZxAllList, Jy, JyTjList, Yx, YxTjList } from "@/api/news";
import Preview from "@/components/common/preview";

export default {
  name: "Invest",
  components:{
    Preview
  },
  data() {
    return {
      itemList: [],
      itemDxList: [],
      itemZxList: [],
      itemCxList: [],
      itemJyList: [],
      itemTjAllList:[],
      itemTjJyList:[],
      itemTjYxList:[],
      itemYxList:[],
      currentTab:'second',
      activeName: 'second',
      VisiAble: false,
      token: window.localStorage.getItem('token'),
      page: 1,
      zxPage: 1,
      dxPage: 1,
      jyPage: 1,
      yxPage: 1,
      total: 0,
      currentPage:1,
      totalCount:1,
      PageSize:5,
      pageSizes:[1,5,10,20],
      btnFlag: false,
      currentIndex:'',
      menuList:[
        {
          imgUrl: require('../assets/images/icon_投顾2.png'),
          imgUrls: require('../assets/images/icon_投顾1.png'),
          txt: '短线',
          desc: '决策自有天机，投资快人一步！（更新频率：交易日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_投顾2.png'),
          imgUrls: require('../assets/images/icon_投顾1.png'),
          txt: '中线',
          desc: '前瞻月度行情，覆盖顶层趋势、策略研判，题材个股和月度股池（更新频率：月末）'
        },
        // {
        //   imgUrl: require('../assets/images/icon_投顾2.png'),
        //   imgUrls: require('../assets/images/icon_投顾1.png'),
        //   txt: '长线',
        //   desc: '着眼于未来半年内的重大投资节点，选择有底线支撑和成长逻辑的价值金股（更新频率：季末）'
        // },
      ]
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getInvestAllList()
    this.getDxList()
    this.getZxList()
    this.getAllZxList()
    this.getCxList()
    this.getJyList()
    this.getYxList()
    this.getAllJyList()
    this.getAllYxList()
  },
  mounted() {
    this.toJump()
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    handlePreview(data) {
      this.VisiAble=true;
      this.$nextTick(()=>{
        this.$refs.dialog.init(data);
      })
    },
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeName = this.$route.query.activeName;
        this.currentTab = this.$route.query.currentTab;
        const currentIn = this.currentTab;
        // console.log(currentIn);
        if(currentIn ==='first'){
          this.currentIndex = 0
        }else if(currentIn === 'second' || currentIn === 'fourth' || currentIn === 'five'){
          this.currentIndex = 1
        }else if(currentIn === 'third'){
          this.currentIndex = 2
        }
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.PageSize = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getCxList(val);
    },
    selectMenu(index) {
      this.currentIndex = index
      // console.log(this.currentIndex);
    },
    getInvestAllList() {
      InvestAll({id: '1569u41apo5', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    getDxList() {
      Dx({id: '8393f85j6i', page: this.dxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemDxList = this.itemDxList.concat(response.data.data)
        }
      });
    },
    getZxList() {
      Zx({id: 'lus8qrz69', page: this.zxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemZxList = this.itemZxList.concat(response.data.data)
        }
      });
    },
    getJyList() {
      Jy({id: '14vn0ay6aod', page: this.jyPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemJyList = this.itemJyList.concat(response.data.data)
        }
      });
    },
    getYxList() {
      Yx({id: 'qi41ka8blc', page: this.yxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYxList = this.itemYxList.concat(response.data.data)
        }
      });
    },
    getCxList(n1) {
      Cx({page:n1,limit:10}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemCxList = response.data.data
          this.currentPage = n1
          this.PageSize = response.data.limit
          this.totalCount = response.data.total
        }
      });
    },
    getAllZxList() {
      ZxAllList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTjAllList = this.itemTjAllList.concat(response.data.data)
        }
      });
    },
    getAllJyList() {
      JyTjList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTjJyList = this.itemTjJyList.concat(response.data.data)
        }
      });
    },
    getAllYxList() {
      YxTjList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTjYxList = this.itemTjYxList.concat(response.data.data)
        }
      });
    },
    getMore() {
      this.page++;
      this.getInvestAllList()
    },
    getAllTjMore() {
      this.page++;
      this.getAllZxList()
    },
    getDxMore() {
      this.dxPage++;
      this.getDxList()
    },
    getZxMore() {
      this.zxPage++;
      this.getZxList()
    },
    getCxMore() {
      this.page++;
      this.getCxList()
    },
    getJyMore() {
      this.jyPage++;
      this.getJyList()
    },
    getJyTjMore() {
      this.page++;
      this.getAllJyList()
    },
    getYxMore() {
      this.yxPage++;
      this.getYxList()
    },
    getYxTjMore() {
      this.page++;
      this.getAllYxList()
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  }
}
</script>

<style scoped>
.invest {
  background-color: #F5F7FA;
}
.invest-box {
  width: 1200px;
  margin: -30px auto 0;
}
.active{
  color: #ffe400;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 50px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.zx-list {
  width: 1200px;
  margin-top: 10px;
  display: flex;
}

.main-content{
  display: flex;
  width: 1200px;
}

.zx-list .left {
  width: 900px;
  margin-right: 10px;
}

.zx-list .right {
  width: 300px;
  margin-top: -44px;
}

.zx-list .right .recommend .recommend-list:not(:first-child) {
  padding: 30px 0;
  background: #fff;
  margin-top: 14px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.zx-list .right .recommend .recommend-list ul {
  width: 260px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li:not(:last-child) {
  border-bottom: 1px solid #cdcdcd;
  margin-bottom: 30px;
}

.zx-list .right .recommend .recommend-list li img {
  width: 260px;
  height: 120px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li .recommend-title {
  margin: 15px 0;
  font-size: 14px;
  color: #313131;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.zx-list .right .recommend .top .title {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  background-image: linear-gradient(#0c255c, #040f27);
}

.zx-list .right .recommend .recommend-list li .recommend-bottom {
  font-size: 12px;
  color: #898989;
  margin-bottom: 23px;
}

.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}

>>>.el-table__row{
  cursor: pointer;
}

>>> .el-tabs__item {
  width: 160px;
  text-align: center;
  color: #313131;
  background-color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

>>> .is-active {
  color: #FFFFFF;
  height: 30px;
  background-image: linear-gradient(#0c255c, #040f27);
}

>>> .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}


</style>



// WEBPACK FOOTER //
// src/components/Invest.vue